import { render, staticRenderFns } from "./RenewalTyjManagement.vue?vue&type=template&id=26f327b8&scoped=true&"
import script from "./RenewalTyjManagement.vue?vue&type=script&lang=js&"
export * from "./RenewalTyjManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f327b8",
  null
  
)

export default component.exports